import React, { useEffect, useState } from "react";

function pad(n) { return String(n).padStart(2, "0"); }

export default function CountdownTimer({ target, dropName, compact = false }) {
  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(t);
  }, []);
  if (!target) return null;
  const end = new Date(target).getTime();
  const diff = Math.max(0, end - now);
  const days = Math.floor(diff / 86400000);
  const hours = Math.floor((diff / 3600000) % 24);
  const mins = Math.floor((diff / 60000) % 60);
  const secs = Math.floor((diff / 1000) % 60);
  const live = diff === 0;

  const size = compact ? "text-3xl md:text-4xl" : "text-5xl md:text-7xl";
  const labelSize = compact ? "text-[10px]" : "text-xs";

  return (
    <div data-testid="countdown-timer" className="text-white">
      <div className={`flex items-center gap-2 mono text-mono ${labelSize} uppercase tracking-[0.3em] text-zinc-500 mb-3`}>
        <span className="h-2 w-2 rounded-full bg-adrenaline animate-pulse-red" /> {live ? "DROPPING NOW" : dropName || "NEXT DROP"}
      </div>
      <div className={`text-mono font-bold ${size} flex items-end gap-2 tabular-nums`}>
        <Unit value={days} label="D" />
        <span className="colon-blink">:</span>
        <Unit value={hours} label="H" />
        <span className="colon-blink">:</span>
        <Unit value={mins} label="M" />
        <span className="colon-blink">:</span>
        <Unit value={secs} label="S" />
      </div>
    </div>
  );
}

function Unit({ value, label }) {
  return (
    <div className="flex flex-col items-center leading-none">
      <span data-testid={`countdown-${label.toLowerCase()}`}>{pad(value)}</span>
      <span className="text-mono text-[10px] md:text-xs tracking-[0.3em] text-zinc-600 mt-2">{label}</span>
    </div>
  );
}
